@if (authService.isInitializing()) {
  <div class="app-splash-screen">
    <div class="splash-content">
      <div class="spinner"></div>
      <p class="splash-text">{{ 'app.loading' | transloco }}</p>
    </div>
  </div>
}

<router-outlet />
